export default {
	title: "Niveau VIP",
	current: "Niveau VIP actuel",
	status: {
		btn: ["Activé", "Inscrivez-vous maintenant"]
	}
};
